import Home from './index/index.vue'
import Sorry from './sorry/sorry.vue'
import Success from './success/success.vue'

export default {
  use: (Vue, Router) => {
    Vue.use(Router);
    const { routerPreFix } = require('$proDirname/prefix')
    const prefix = window?.ssrConfig?.routerConfig?.name ?? `/${routerPreFix.taxiActivityCoupon}/index`;
    console.log("prefix", prefix)
    const router = new Router({
      mode: 'history',
      prefix,
      routes: [
        {
          path: `*`,
          redirect: `${prefix}/home`
        },
        {
          name: 'home',
          path: `${prefix}/home`,
          component: Home
        },
        {
          name: 'sorry',
          path: `${prefix}/sorry`,
          component: Sorry
        },
        {
          name: 'gc',
          path: `${prefix}/gc`,
          component: Success
        },
      ]
    });
    return router;
  }
};
